<div class="flex flex-col gap-6 max-w-4xl mx-auto w-full pt-4">
  <!-- Tabs bar skeleton -->
  <div class="flex gap-4 border-b border-gray-4 pb-2">
    @for (t of [1, 2]; track t) {
      <ngx-skeleton-loader
        [theme]="{ width: '100px', height: '24px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
    }
  </div>

  <!-- Card summary skeleton -->
  <div class="surface-default flex flex-col gap-3 rounded-xl border border-gray-5 p-6 shadow-sm">
    <ngx-skeleton-loader
      [theme]="{ width: '40%', height: '20px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
    <ngx-skeleton-loader
      [theme]="{ width: '25%', height: '16px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
    <ngx-skeleton-loader
      [theme]="{ width: '35%', height: '16px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
  </div>

  <!-- Content preview skeleton -->
  <div
    class="surface-default rounded-xl border border-gray-5 p-6 flex flex-col gap-4 shadow-sm min-h-[260px]"
  >
    <ngx-skeleton-loader
      [theme]="{ width: '55%', height: '22px', 'border-radius': '6px', margin: '0' }"
      animation="pulse"
    />
    <ngx-skeleton-loader
      [theme]="{ width: '100%', height: '16px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
    <ngx-skeleton-loader
      [theme]="{ width: '90%', height: '16px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
    <ngx-skeleton-loader
      [theme]="{ width: '75%', height: '16px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
  </div>
</div>
